import React from 'react';
import PropTypes from 'prop-types';
import './style.less';
import mobx from 'mobx';
import Icon from '../Icon';
import { Modal } from 'antd-mobile';
import Calendar from '../Calendar/Calendar';

const preventEvent = (event) => {
  if (event) {
    event.preventDefault();
    event.stopImmediatePropagation && event.stopImmediatePropagation();
    event.stopPropagation();
  }
};

export default class DatePick extends React.Component {

  static propTypes = {
    value: PropTypes.string, // 
    onChange: PropTypes.func, // 
  }

  state = {}

  dateRangeClick = (date) => {
    this.setState({
      open: false
    });
    this.props.onChange && this.props.onChange(date)
  }

  showPicker = (e) => {
    preventEvent(e);
    this.setState({
      open: true,
      anchorEl: document.body
    });
  }

  handleRequestClose = () => {
    this.setState({
      open: false
    });
  }

  render() {
    const { value, name } = this.props;
    return (
      <React.Fragment>
        <div className={`datepick ${value ? '': 'text-align-right'}`} onClick={this.showPicker} >
          {value || <Icon type='rili' />}
        </div>
        <Modal
          popup
          wrapClassName='datepick-modal-wrap'
          visible={this.state.open}
          onClose={this.handleRequestClose}
          animationType="slide-down">
          <Calendar startDate={value} endDate={value} dateClick={this.dateRangeClick} />
        </Modal>
      </React.Fragment>
    )
  }

}
